/* Maison Alméa — avis (partie 2). 30/09 perf : sorti de sections/almea-com-avis.liquid (cache). */

(function(){
  if (window.__almsecDemo) return;
  window.__almsecDemo = true;
  var go = function(){
    var tpls = document.querySelectorAll('[data-almsec-demo],[data-almsec-demo-note],[data-almsec-demo-filtres]');
    if (!tpls.length) return;
    var role = '';
    try { role = (window.Shopify && Shopify.theme && Shopify.theme.role) || ''; } catch (e) {}
    /* Sécurité : sur le thème PUBLIÉ, rien n'est jamais injecté — ni les cartes,
       ni la note moyenne, ni le filtre. Et comme tout vit dans un <template>,
       l'absence de JavaScript donne le même résultat : rien. */
    var publie = (role === 'main' || role === 'live' || role === 'published');

    function viderTemplates(injecter){
      Array.prototype.forEach.call(tpls, function (tpl) {
        if (!tpl.content) return;
        if (injecter) tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
        tpl.remove();
      });
    }
    if (publie) { viderTemplates(false); return; }

    /* Fichier de démonstration propre au produit ? Il gagne sur tout le reste. */
    var src = document.querySelector('[data-almsec-demo-src]');
    if (!src) { viderTemplates(true); return; }

    fetch(src.getAttribute('data-almsec-demo-src'), { cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) {
        var liste = (d && (d.liste || d.avis)) || d;
        if (!liste || !liste.length) throw 0;
        /* 02/09 — les avis AVEC PHOTO passent devant : c'est ce qui rassure le plus
           et c'est ce qu'on voit en premier dans le carrousel. */
        liste = liste.slice().sort(function(a,b){
          var pa = (a.img || a.image) ? 0 : 1, pb = (b.img || b.image) ? 0 : 1;
          return pa - pb;
        });
        viderTemplates(false);
        construire(liste);
      })
      .catch(function () { viderTemplates(true); });

    function etoilesHtml(n){
      var h = '<span class="almsec-stars" aria-hidden="true">';
      for (var i = 1; i <= 5; i++) h += '<span' + (i > n ? ' class="almsec-star--off"' : '') + '><svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.6 1.4 6.8L12 17.1 5.9 20.5l1.4-6.8L2.2 9.1l6.9-.8z"/></svg></span>';
      return h + '</span>';
    }
    /* 03/09 — le guillemet DOIT etre echappe : la liste des photos passe par un
       attribut HTML, et un JSON non echappe cassait l'attribut en plein milieu
       (la pastille « +3 » s'affichait, mais la visionneuse ne voyait qu'une photo). */
    function ech(t){ return String(t == null ? '' : t).replace(/[<>&"]/g, function(c){ return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c]; }); }

    function construire(liste){
      var sec = document.getElementById('avis-clients-section');
      if (!sec) return;
      var rail = sec.querySelector('[data-almsec-rail]');
      var head = sec.querySelector('.almsec-avis-head');
      if (!rail || !head) return;

      var cbg = src.getAttribute('data-check-bg') || '#2E7CF6';
      var cfg = src.getAttribute('data-check-fg') || '#FFFFFF';
      var pastille = '<svg class="almsec-avis__check" viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
        + '<path fill="' + cbg + '" d="M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81C14.67 2.63 13.43 1.75 12 1.75s-2.67.88-3.34 2.19c-1.39-.46-2.9-.2-3.91.81s-1.27 2.52-.81 3.91c-1.31.67-2.19 1.91-2.19 3.34s.88 2.67 2.19 3.34c-.46 1.39-.2 2.9.81 3.91s2.52 1.27 3.91.81c.67 1.31 1.91 2.19 3.34 2.19s2.67-.88 3.34-2.19c1.39.46 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.67 2.19-1.91 2.19-3.34z"/>'
        + '<path fill="' + cfg + '" d="M10.98 16.28l-3.4-3.4 1.41-1.41 1.99 1.99 4.24-4.24 1.41 1.41-5.65 5.65z"/></svg>';
      var n = [0,0,0,0,0,0], total = 0, somme = 0, html = '';
      liste.forEach(function (a, i) {
        var t = a.t || a.texte; if (!t) return;
        var r = parseInt(a.r || a.note || 5, 10); if (!(r >= 1 && r <= 5)) r = 5;
        var nom = a.n || a.nom || 'Customer';
        /* 03/09 — UN AVIS PEUT AVOIR PLUSIEURS PHOTOS. Un client qui poste quatre
           photos, c'est UN avis, pas quatre. On garde la premiere sur la carte avec
           une pastille « +3 », et la visionneuse les fait toutes defiler. */
        var brut = a.img || a.image || [];
        if (!Array.isArray(brut)) brut = brut ? [brut] : [];
        var base = src.getAttribute('data-almsec-demo-src').split('/assets/')[0] + '/assets/';
        var urls = brut.map(function(x){ x = String(x).trim(); return x.indexOf('//') > -1 ? x : base + x; }).filter(Boolean);
        var url = urls[0] || '';
        total++; somme += r; n[r]++;
        html += '<div class="almsec-avis__c" data-rv data-note="' + r + '"'
             + (urls.length > 1 ? ' data-photos="' + ech(JSON.stringify(urls)) + '"' : '')
             + ' style="--rvd:' + (i * 40) + 'ms">'
             + (url ? '<a class="almsec-avis__img" href="' + ech(url) + '" aria-label="Enlarge the review photo"><img src="' + ech(url) + '" alt="" loading="lazy" decoding="async">'
                 + (urls.length > 1 ? '<span class="almsec-avis__plus">+' + (urls.length - 1) + '</span>' : '') + '</a>' : '')
             + '<p class="almsec-avis__txt">' + ech(t) + '</p>'
             + '<span class="almsec-avis__v">' + pastille + 'Verified customer'
             + (a.d ? '<span class="almsec-avis__d">· ' + ech(a.d) + '</span>' : '') + '</span>'
             + '<span class="almsec-avis__f"><span class="almsec-avis__who">'
             + '<span class="almsec-avis__av">' + ech(nom.charAt(0)) + '</span>'
             + '<span class="almsec-avis__n">' + ech(nom) + '</span></span>'
             + etoilesHtml(r) + '<span class="almsec-avis__note">' + r + '/5</span></span></div>';
      });
      if (!total) return;
      rail.insertAdjacentHTML('beforeend', html);

      var moy = (somme / total).toFixed(1).replace('.', ',');
      var note = document.createElement('p');
      note.className = 'almsec-avis-note';
      note.innerHTML = etoilesHtml(5) + ' ' + moy + '/5 sur ' + total + ' reviews';
      head.insertBefore(note, head.firstChild);

      var niveaux = 0; for (var k = 1; k <= 5; k++) if (n[k]) niveaux++;
      if (niveaux > 1) {
        var f = '<div class="almsec-avis-filtres" data-almsec-filtres role="group" aria-label="Filter reviews by rating">'
              + '<button type="button" class="almsec-avis-f is-on" data-f="0" aria-pressed="true">All <i>' + total + '</i></button>';
        for (var e = 5; e >= 1; e--) if (n[e]) {
          f += '<button type="button" class="almsec-avis-f" data-f="' + e + '" aria-pressed="false">' + e
            + '<svg class="almsec-avis-f__s" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.6 1.4 6.8L12 17.1 5.9 20.5l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>'
            + '<i>' + n[e] + '</i></button>';
        }
        head.insertAdjacentHTML('afterend', f + '</div>');
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();

;

(function(){
  /* 09/09 — LES FLECHES N'ETAIENT BRANCHEES SUR RIEN.
     Les deux boutons etaient bien rendus et bien styles, mais aucun script du
     theme n'ecoutait [data-almsec-prev] / [data-almsec-next] : sur mobile on
     s'en sortait au doigt, sur PC le carrousel etait donc totalement fige.
     Delegation sur document : les cartes sont injectees APRES ce script par le
     bloc de demonstration, se brancher sur le rail au chargement ne marcherait pas. */
  if (window.__almsecFleches) return; window.__almsecFleches = 1;

  function rail(el){
    var w = el.closest ? el.closest('.almsec-avis-wrap') : null;
    return w ? w.querySelector('[data-almsec-rail]') : null;
  }

  /* Un « pas » = la largeur d'une carte visible + l'espace entre deux cartes.
     On mesure au moment du clic : le filtre par note peut avoir masque des cartes. */
  function pas(r){
    var c = r.querySelector('.almsec-avis__c:not([hidden])');
    if (!c) return Math.round(r.clientWidth * 0.8);
    var st = getComputedStyle(r);
    var gap = parseFloat(st.columnGap || st.gap || '0') || 0;
    return Math.round(c.getBoundingClientRect().width + gap);
  }

  function majEtat(r){
    var w = r.closest('.almsec-avis-wrap'); if (!w) return;
    var p = w.querySelector('[data-almsec-prev]'), n = w.querySelector('[data-almsec-next]');
    var max = r.scrollWidth - r.clientWidth - 2;
    if (p) p.classList.toggle('is-off', r.scrollLeft <= 2);
    if (n) n.classList.toggle('is-off', r.scrollLeft >= max);
  }

  function glisser(r, sens){
    var d = pas(r) * sens;
    var depart = r.scrollLeft;
    try { r.scrollBy({ left: d, behavior: 'smooth' }); }
    catch (e) { r.scrollLeft = depart + d; }
    /* Filet de securite : sur certains navigateurs, un defilement anime entre en
       conflit avec l'accrochage obligatoire des cartes et ne demarre jamais.
       Si rien n'a bouge au bout de 350 ms, on saute directement a la bonne carte. */
    setTimeout(function(){
      if (Math.abs(r.scrollLeft - depart) < 4) {
        var snap = r.style.scrollSnapType, comp = r.style.scrollBehavior;
        r.style.setProperty('scroll-behavior', 'auto', 'important');
        r.scrollLeft = depart + d;
        r.style.scrollBehavior = comp; r.style.scrollSnapType = snap;
      }
      majEtat(r);
    }, 350);
    setTimeout(function(){ majEtat(r); }, 800);
  }

  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('[data-almsec-prev],[data-almsec-next]') : null;
    if (!b) return;
    var r = rail(b); if (!r) return;
    e.preventDefault();
    glisser(r, b.hasAttribute('data-almsec-next') ? 1 : -1);
  }, false);

  /* Etat des fleches (grisees en bout de course) + prise en main a la souris.
     Le glisser-deposer est indispensable sur PC : la barre de defilement du rail
     est masquee, et une molette verticale ne fait pas defiler horizontalement. */
  function brancher(r){
    if (r.__almsecOk) return; r.__almsecOk = 1;
    r.addEventListener('scroll', function(){ majEtat(r); }, { passive: true });
    majEtat(r);

    var down = false, moved = false, x0 = 0, sl0 = 0;
    r.addEventListener('pointerdown', function(ev){
      if (ev.pointerType !== 'mouse' || ev.button !== 0) return;
      down = true; moved = false; x0 = ev.clientX; sl0 = r.scrollLeft;
    });
    r.addEventListener('pointermove', function(ev){
      if (!down) return;
      var d = ev.clientX - x0;
      if (!moved && Math.abs(d) < 6) return;
      moved = true;
      r.style.scrollSnapType = 'none';
      r.style.cursor = 'grabbing';
      r.scrollLeft = sl0 - d;
      ev.preventDefault();
    });
    function fin(ev){
      if (!down) return;
      down = false;
      r.style.cursor = '';
      r.style.scrollSnapType = '';
      /* Un glissement ne doit pas ouvrir la visionneuse de la photo survolee. */
      if (moved && ev) {
        var stop = function(c){ c.stopPropagation(); c.preventDefault(); };
        r.addEventListener('click', stop, true);
        setTimeout(function(){ r.removeEventListener('click', stop, true); }, 0);
      }
    }
    r.addEventListener('pointerup', fin);
    r.addEventListener('pointercancel', fin);
    r.addEventListener('pointerleave', fin);
  }

  function scan(){
    var l = document.querySelectorAll('.almsec-avis-wrap [data-almsec-rail]');
    /* majEtat A CHAQUE passage, pas seulement au branchement : les cartes sont
       injectees apres coup, et un premier calcul sur un rail encore vide grisait
       les deux fleches pour de bon. */
    for (var i = 0; i < l.length; i++) { brancher(l[i]); majEtat(l[i]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  /* Les cartes arrivent apres coup (bloc de demonstration) : on repasse. */
  setTimeout(scan, 400); setTimeout(scan, 1200); setTimeout(scan, 3000);
  document.addEventListener('shopify:section:load', scan);
})();

;

/* 10/09 : les photos d'avis arrivaient trop tard (lazy declenche au dernier moment).
   On les passe en chargement immediat des que la section approche de l'ecran. */
(function(){
  if (window.almeaAvisPrecharge) return; window.almeaAvisPrecharge = 1;
  function boost(sec){
    var im = sec.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < im.length && i < 8; i++){
      im[i].setAttribute('loading','eager');
      im[i].setAttribute('fetchpriority', i < 4 ? 'high' : 'low');
    }
  }
  function arm(){
    var sec = document.getElementById('avis-clients-section');
    if (!sec) return false;
    if (!('IntersectionObserver' in window)) { boost(sec); return true; }
    var io = new IntersectionObserver(function(ent){
      if (ent[0].isIntersecting){ boost(sec); io.disconnect(); }
    }, { rootMargin: '1200px 0px' });
    io.observe(sec);
    return true;
  }
  if (!arm()) document.addEventListener('DOMContentLoaded', arm);
}());

;

(function(){
  /* 25/09 03h30 (Lancelot, maquette 1) : réorganise la section avis déjà rendue — rien n'est retiré du HTML, les anciens blocs sont seulement masqués. */
  function run(){
    var sec = document.getElementById('avis-clients-section'); if (!sec) return true;
    if (sec.getAttribute('data-s1')) return true;
    var head = sec.querySelector('.almsec-avis-head'), filt = sec.querySelector('[data-almsec-filtres]'), rail = sec.querySelector('[data-almsec-rail]'), wrap = sec.querySelector('.almsec-avis-wrap');
    var sc = sec.querySelector('.almsec-avis-score');
    if (!head || !filt || !rail || !wrap || !sc) return false;
    sec.setAttribute('data-s1', '1'); sec.classList.add('alm-s1');
    sec.style.setProperty('background-color', '#f6f6f4', 'important');
    var num = sc.textContent.replace(/\s*sur\s*5\s*/, '').trim();
    var ce = sec.querySelector('.almsec-avis-count'), cnt = ce ? (parseInt(ce.textContent.replace(/\D/g, ''), 10) || 0) : 0;
    var me = sec.querySelector('.almsec-avis-mention'), men = me ? me.textContent.trim() : '';
    var counts = {};
    var fb = filt.querySelectorAll('.almsec-avis-f');
    for (var i = 0; i < fb.length; i++) { var it = fb[i].querySelector('i'); counts[fb[i].getAttribute('data-f')] = it ? (parseInt(it.textContent, 10) || 0) : 0; }
    var top = document.createElement('div'); top.className = 's1-top';
    top.innerHTML = '<div class="s1-sum"><span class="s1-big">' + num + '</span><div><div class="s1-sq" aria-hidden="true"><span><svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 2.5l2.8 6.1 6.7.7-5 4.5 1.4 6.6L12 17.1l-5.9 3.3 1.4-6.6-5-4.5 6.7-.7z\"/></svg></span><span><svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 2.5l2.8 6.1 6.7.7-5 4.5 1.4 6.6L12 17.1l-5.9 3.3 1.4-6.6-5-4.5 6.7-.7z\"/></svg></span><span><svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 2.5l2.8 6.1 6.7.7-5 4.5 1.4 6.6L12 17.1l-5.9 3.3 1.4-6.6-5-4.5 6.7-.7z\"/></svg></span><span><svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 2.5l2.8 6.1 6.7.7-5 4.5 1.4 6.6L12 17.1l-5.9 3.3 1.4-6.6-5-4.5 6.7-.7z\"/></svg></span><span><svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 2.5l2.8 6.1 6.7.7-5 4.5 1.4 6.6L12 17.1l-5.9 3.3 1.4-6.6-5-4.5 6.7-.7z\"/></svg></span></div><div class="s1-meta">sur 5 · ' + cnt + ' reviews</div></div></div>';
    var bars = document.createElement('div'); bars.className = 's1-bars'; bars.setAttribute('role', 'group'); bars.setAttribute('aria-label', 'Filter reviews by rating');
    [5, 4, 3, 2, 1].forEach(function (k) {
      var n = counts[k] || 0, pct = cnt ? Math.round(n / cnt * 100) : 0;
      var b = document.createElement('button'); b.type = 'button'; b.className = 's1-bar'; b.setAttribute('data-k', k); if (!n) b.disabled = true;
      b.setAttribute('aria-label', k + ' stars: ' + n + ' reviews');
      b.innerHTML = '<span>' + k + ' ★</span><span class="s1-tr"><span style="width:' + pct + '%"></span></span><span>' + n + '</span>';
      bars.appendChild(b);
    });
    top.appendChild(bars);
    head.appendChild(top);
    var lbl = document.createElement('span');
    bars.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.s1-bar') : null; if (!b || b.disabled) return;
      var on = b.classList.contains('is-on'), k = b.getAttribute('data-k');
      var t = filt.querySelector('.almsec-avis-f[data-f="' + (on ? '0' : k) + '"]'); if (t) t.click();
      var all = bars.querySelectorAll('.s1-bar'); for (var j = 0; j < all.length; j++) all[j].classList.toggle('is-on', !on && all[j] === b);
      bars.classList.toggle('has-f', !on);
      vus = on ? PAS : 100000; limite();
      lbl.textContent = on ? '' : ('Filtre : ' + k + ' ★');
    });
    /* photos de clients */
    var imgs = rail.querySelectorAll('.almsec-avis__c .almsec-avis__img');
    if (imgs.length) {
      var hh = document.createElement('div'); hh.className = 's1-phh'; hh.innerHTML = '<b>Customer photos</b>'; hh.appendChild(lbl);
      var ph = document.createElement('div'); ph.className = 's1-ph';
      var thumbs = [];
      for (var p = 0; p < imgs.length; p++) (function (a) {
        var bt = document.createElement('button'); bt.type = 'button'; bt.setAttribute('aria-label', 'View customer photo');
        var cn = a.closest('.almsec-avis__c'), ne = cn ? cn.querySelector('.almsec-avis__n') : null, pn = ne ? ne.textContent.trim().split(/\s+/)[0] : '';
        if (pn) { var lb = document.createElement('span'); lb.className = 's1-ph__n'; lb.textContent = pn; bt.appendChild(lb); }
        bt.addEventListener('click', function () { a.click(); });
        ph.appendChild(bt); thumbs.push([bt, a]);
      })(imgs[p]);
      function src() { thumbs.forEach(function (t) { var im = t[1].querySelector('img'); if (!im) return; var s = im.currentSrc || im.getAttribute('src') || im.getAttribute('data-src') || ''; if (s && s.indexOf('data:') !== 0) t[0].style.backgroundImage = 'url("' + s + '")'; }); }
      /* 25/09 04h40 perf : les miniatures ne se téléchargent que quand la section approche de l'écran (avant : 12 photos au chargement) */
      var go = function () { src(); setTimeout(src, 1500); };
      try { var ioT = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { ioT.disconnect(); go(); } }, { rootMargin: '600px 0px' }); ioT.observe(ph); } catch (e) { go(); }
      wrap.parentNode.insertBefore(hh, wrap); wrap.parentNode.insertBefore(ph, wrap);
      /* 26/09 03h05 (Lancelot : « photos de clients en carrousel auto, assez lent ») : défilement continu doux (~22 px/s),
         pause dès qu'on touche ou survole, reprise 3 s après ; boucle sans fin (miniatures doublées) ; arrêté si « moins d'animations ». */
      (function () {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var n0 = thumbs.length; if (n0 < 3) return;
        thumbs.slice(0, n0).forEach(function (t) {
          var c = t[0].cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.tabIndex = -1;
          c.addEventListener('click', function () { t[1].click(); });
          ph.appendChild(c); thumbs.push([c, t[1]]);
        });
        /* 28/09 04h05 (Claude, vitesse) : la largeur n'est plus relue à chaque image (recalcul forcé) ; mesurée une fois, puis au redimensionnement. */
        var SPEED = 22, last = 0, pos = 0, pause = 0, vis = false, raf = 0, H = 0, sync = false;
        function mesure() { H = ph.scrollWidth / 2; }
        try { window.addEventListener('resize', function () { H = 0; }, { passive: true }); } catch (e) {}
        function step(ts) {
          raf = 0; if (!vis) return;
          var dt = last ? Math.min(64, ts - last) : 16; last = ts;
          if (Date.now() > pause) {
            if (sync) { sync = false; pos = ph.scrollLeft; }
            if (!H) mesure();
            pos += SPEED * dt / 1000;
            if (H > 0 && pos >= H) pos -= H;
            ph.scrollLeft = pos;
          } else { sync = true; }
          raf = requestAnimationFrame(step);
        }
        /* 28/09 (Lancelot : « dès que je touche sur mobile ça s'arrête, je veux pas ») : plus d'arrêt de 3 s.
           Le défilement ne s'interrompt que PENDANT que le doigt glisse, et repart aussitôt le doigt levé (depuis l'endroit où on l'a laissé).
           Plus aucune pause au survol de la souris. */
        var doigt = false;
        ph.addEventListener('touchstart', function () { doigt = true; pause = Date.now() + 60000; }, { passive: true });
        ['touchend', 'touchcancel'].forEach(function (ev) { ph.addEventListener(ev, function () { doigt = false; pause = Date.now() + 250; }, { passive: true }); });
        ph.addEventListener('wheel', function () { if (!doigt) pause = Date.now() + 400; }, { passive: true });
        try {
          new IntersectionObserver(function (en) { vis = en.some(function (x) { return x.isIntersecting; }); if (vis && !raf) { last = 0; pos = ph.scrollLeft; raf = requestAnimationFrame(step); } }).observe(ph);
        } catch (e) { vis = true; raf = requestAnimationFrame(step); }
      })();
    }
    /* étoiles au-dessus du texte */
    var cards = rail.querySelectorAll('.almsec-avis__c');
    for (var c = 0; c < cards.length; c++) { var st = cards[c].querySelector('.almsec-avis__f .almsec-stars'), tx = cards[c].querySelector('.almsec-avis__txt'); if (st && tx) cards[c].insertBefore(st, tx); }
    /* voir tous les avis */
    /* 25/09 03h40 (Lancelot) : « voir plus d'avis » = on ajoute des avis DANS le carrousel horizontal (pas de liste verticale).
       Les avis au-delà du 12e arrivent plus tard (dépliés par un autre script) : la limite est donc réappliquée à chaque arrivée. */
    var PAS = 6, vus = PAS;
    var more = document.createElement('button'); more.type = 'button'; more.className = 's1-all'; more.textContent = 'See more reviews';
    function limite() {
      var cc = rail.querySelectorAll('.almsec-avis__c');
      for (var q = 0; q < cc.length; q++) {
        cc[q].classList.toggle('s1-x', q >= vus);
        if (!cc[q].getAttribute('data-s1c')) { cc[q].setAttribute('data-s1c', '1'); var st2 = cc[q].querySelector('.almsec-avis__f .almsec-stars'), tx2 = cc[q].querySelector('.almsec-avis__txt'); if (st2 && tx2) cc[q].insertBefore(st2, tx2); }
      }
      more.hidden = vus >= cc.length;
    }
    try { new MutationObserver(limite).observe(rail, { childList: true }); } catch (e) {}
    more.addEventListener('click', function () {
      var avant = vus; vus += PAS; limite();
      var cc = rail.querySelectorAll('.almsec-avis__c'), premier = null;
      for (var q = avant; q < cc.length && !premier; q++) if (!cc[q].hidden && cc[q].offsetWidth) premier = cc[q];
      if (premier) { try { rail.scrollTo({ left: premier.offsetLeft - rail.firstElementChild.offsetLeft, behavior: 'smooth' }); } catch (e) { rail.scrollLeft = premier.offsetLeft; } }
    });
    limite();
    wrap.parentNode.insertBefore(more, wrap.nextSibling);
    return true;
  }
  var tries = 0;
  (function go(){ if (run() || ++tries > 40) return; setTimeout(go, 250); })();
})();
